/**
 * Created by greg on 31/05/2018.
 */
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {
    Inject, Component, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef, Input,
    Output,
    EventEmitter
} from '@angular/core';
import {PaymentService} from "../../../payment/payment.service";
import * as XLSX from 'xlsx';
import { AngularFireStorage } from 'angularfire2/storage';
import { StateService } from 'app/core/state.service';
import {AuthService} from '../../../core/auth.service';
import { Subject } from "rxjs/Subject";
import {Observable} from "rxjs/Rx";
import {Source, Charge, SourceAddress} from "../../../payment/models";
import {TaxService} from "../../../payment/taxes.service";

/**
 * Created by greg on 9/03/2018.
 */

@Component({
    selector: 'payment-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>Payment Method</div>
    <form #paymentForm="ngForm" (ngSubmit)="formHandler()" class="checkout">
        <div mat-dialog-content >
            <div>
                <label for="nameOnCard">Name on card</label>
                <mat-form-field >
                    <input matInput id="nameOnCard" name="nameOnCard" required [(ngModel)]="card_holder.nameOnCard" #nameOnCard="ngModel">
                </mat-form-field>
                
                <label for="line1">Address line 1<span>(Street address/PO Box/Company name)</span></label>
                <mat-form-field >
                    <input matInput id="line1" name="line1" required [(ngModel)]="card_holder.line1" #line1="ngModel">
                </mat-form-field>
                
                <label for="line2">Address line 2<span>(Apartment/Suite/Unit/Building)</span></label>
                <mat-form-field >
                    <input matInput id="line2" name="line2" required [(ngModel)]="card_holder.line2" #line2="ngModel">
                </mat-form-field>
                
                <label for="city">City/District/Suburb/Town</label>
                <mat-form-field >
                    <input matInput id="city" name="city" required [(ngModel)]="card_holder.city" #city="ngModel">
                </mat-form-field>
                
                <label for="state">State/County/Province/Region</label>
                <mat-form-field >
                    <input matInput id="state" name="state" required [(ngModel)]="card_holder.state" #state="ngModel">
                </mat-form-field>
                
                <label for="postal_code">ZIP or postal code</label>
                <mat-form-field >
                    <input matInput id="postal_code" name="postal_code" required [(ngModel)]="card_holder.postal_code" #postal_code="ngModel">
                </mat-form-field>
                
                <label for="country">Country<span>(2-letter country code)</span></label>
                <mat-form-field >
                    <input matInput id="country" name="country" required [(ngModel)]="card_holder.country" #country="ngModel">
                </mat-form-field>
    
                <div class="form-row">
                <label>Pay with Credit or Debit Card</label> (4000000360000006) (4242424242424242)
        
                <div id="card-element" #cardElement></div>
                <div id="card-errors" class="help is-danger" role="alert" *ngIf="formError">{{ formError }}</div>
                </div>
                
                <div class="payment_note">This card will be saved to your account to enable subscription payments. You can cancel your subscription at any time from your account. Renewal rates are subject to change, but we will always notify you of any rate change beforehand.</div>
                <div class="authorize">
                    <mat-checkbox required color="primary" name="authorize_payment" required [(ngModel)]="card_holder.authorize_payment"></mat-checkbox>
                    <div class="authorize_text">I have read and agree to the terms and conditions and authorize payments.</div>
                </div>
                
            </div>
            
        </div>        
        <mat-progress-bar *ngIf="loading" mode="indeterminate" color="primary" ></mat-progress-bar>

        <div mat-dialog-actions>
            <button mat-button (click)="dialogRef.close()">CANCEL</button>
        
                <div *ngIf="totalAmount; then pay else save;">
                    <!-- ng-template appears here -->
                </div>
        </div>
    </form>
</div>    
 
<!-- Template when Charging Card -->

<ng-template #pay>
    
    <button mat-button color="primary" type="submit" 
            class="button is-info" 
            [disabled]="!formComplete || !paymentForm.valid || loading"
            [class.is-loading]="loading">

        Pay {{ totalAmount | stripe | currency }}

    </button>

    <div *ngIf="result?.id" class="notification is-success">
        {{ result.id }} has a status of {{ result.status }} for {{ result.amount | stripe | currency }}
    </div>  
    
    <!-- If error, show the user the raw error msg from Stripe -->
    <div *ngIf="result?.error" class="notification is-danger">
        {{ result.error?.message }}
    </div>  

</ng-template>
<ng-template #save>
    <button mat-button color="primary" type="submit" 
        class="button is-info" 
        [disabled]="!formComplete || !paymentForm.valid || loading"
        [class.is-loading]="loading"
        [textContent]="pmt.planId ? 'Subscribe' : 'Save Card'">

    </button>

    <div *ngIf="result?.id" class="notification is-success">
        Attached payment source {{ result.id }} -- {{ result.card.brand }} ending in {{ result.card.last4 }}
    </div>  
    
    <!-- If error, show the user the raw error msg from Stripe -->
    <div *ngIf="result?.error" class="notification is-danger">
        {{ result.error?.message }}
    </div>  

</ng-template>
`,
    styles:[`
.payment_note { font-style: italic; margin-top: 20px; font-size: 12px; line-height: 16px; }
.authorize { display: flex; padding-top: 10px; }
.authorize_text { padding: 5px 0 0 10px; }
.is-danger { color: #f00; font-size: 12px; padding: 10px 10px 0 10px;}
`]
})
export class PaymentDialog {

    card_holder = {
        firstName:'',
        lastName:'',
        company:'',
        line1:'',
        line2:'',
        city:'',
        state:'',
        postal_code:'',
        country:'',
        authorize_payment:false
    }
    country_code;
    // Total amount of the charge
    totalAmount: number;
    sales_tax:number;

    // Emit result of operation to other components
    @Output() stripeResult = new EventEmitter<Charge | Source>();

    // Result used locacally to display status.
    result: Charge | Source;
    @ViewChild('paymentForm') paymentForm: ElementRef;

    // The Stripe Elements Card
    @ViewChild('cardElement') cardElement: ElementRef;
    card: any;
    formError: string;
    formComplete = false;

    // State of async activity
    loading = false;
    action: Observable<any> = Observable.of(null);

    constructor(
        private cd: ChangeDetectorRef,
        public dialogRef: MatDialogRef<PaymentDialog>,
        public pmt:PaymentService,
        public tax:TaxService,
        public auth:AuthService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if(data.prod){
            this.country_code = data.current_country.code;
            this.totalAmount = data.prod.rate * data.prod.quantity * 100;
            if(this.tax.schedule[data.current_country.code] && this.tax.schedule[data.current_country.code].has_sales_tax){
                this.sales_tax = this.tax.schedule[data.current_country.code].calc(this.totalAmount);
                this.totalAmount += this.sales_tax;
            }
        }
    }

    ngAfterViewInit() {
        this.card = this.pmt.elements.create('card');
        this.card.mount(this.cardElement.nativeElement);

        // Listens to change event on the card for validation errors
        this.card.on('change', (evt) => {
            this.formError = evt.error ? evt.error.message : null;
            this.formComplete = evt.complete;
            this.cd.detectChanges();
        })
    }

    // Called when the user submits the form
    formHandler(): void {
        this.loading = true
        const nameOnCard = this.paymentForm['form'].value.nameOnCard;
        if(!nameOnCard) return;
        let address:SourceAddress = {country:this.country_code};
        if(this.paymentForm['form'].value.line1) address.line1 = this.paymentForm['form'].value.line1;
        if(this.paymentForm['form'].value.line2) address.line2 = this.paymentForm['form'].value.line2;
        if(this.paymentForm['form'].value.city) address.city = this.paymentForm['form'].value.city;
        if(this.paymentForm['form'].value.state) address.state = this.paymentForm['form'].value.state;
        if(this.paymentForm['form'].value.postal_code) address.postal_code = this.paymentForm['form'].value.postal_code;
        this.action = this.pmt.attachSource(this.card, nameOnCard, address);
        console.log("action = " ,this.action);
        this.action.subscribe( data => {
            console.log("action data = " ,data);
            if(!data) return;
            console.log('this.pmt.planId = ',this.pmt.planId)
            console.log('this.pmt.planQty = ',this.pmt.planQty)
            this.result = data;
            this.stripeResult.emit(data);
            this.loading = true;
            if(this.totalAmount){
                this.pmt.attachSubscription(data.id, this.pmt.planId, this.pmt.planQty).subscribe(result => {
                    this.loading = false;
                    console.log('attachSubscription returned', result);
                    this.dialogRef.close(data)
                });
            }else{
                data._card_saved = true;
                this.dialogRef.close(data)
                this.loading = false;
            }
        }, err => {
            this.result = err;
            this.loading = false;
        });
    }
    ngOnDestroy() {
        this.card.destroy();
    }

}

@Component({
    selector: 'payment-summary-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog payment-summary-dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>Payment Summary<i></i></div>
    <div mat-dialog-content >
        <div class="current">
            <div class="summary_title">
                Current Subscription
            </div>
            <div class="content">
                <div class="font-bold">{{current_desc}}</div>
                <div>{{current_remaining}}</div>
            </div>
        </div>
        <div>
            <div class="summary_title">
                New Subscription
            </div>
            <div class="content">
                <div class="font-bold">{{new_desc}}</div>
                <div>{{prod.quantity * prod.rate | currency:current_country.currency.toUpperCase():''}}/{{prod.frequency}}</div>
            </div>
        </div>
        <div>
            <div class="summary_title final">
                Order Summary
            </div>
            <div class="content justify-between ">
                <div>{{item_desc}}</div>
                <div>{{prod.quantity * prod.rate | currency:current_country.currency.toUpperCase():''}}</div>
            </div>
            <div class="content justify-between" *ngIf="sales_tax" >
                <div>{{tax.schedule[data.current_country.code].in_summary}}</div>
                <div>{{sales_tax | currency:current_country.currency.toUpperCase():''}}</div>
            </div>
            <div class="bottomline content justify-between">
                <div class="font-bold">Today's total</div>
                <div>{{total | currency:current_country.currency.toUpperCase():''}}</div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="dialogRef.close()">CANCEL</button>
        <button mat-button [mat-dialog-close]="data" color="primary" >Next</button>
    </div>
</div>
`,
    styles:[`
.payment_note { font-style: italic; margin-top: 20px; font-size: 12px; line-height: 16px; }
.summary_title { text-transform: uppercase; padding-bottom: 10px; }
.summary_title.final {margin-top: 50px; font-weight: bold;}
.payment-summary-dialog .content { display: flex; padding: 4px 0; font-size: 12px; }
.payment-summary-dialog .content > div { margin-right: 10px; }
.current { color: #999; margin-bottom: 25px; padding-bottom: 25px; border-bottom: 1px solid #CCCCCC;  }
.bottomline {border-top: 1px solid #CCCCCC;}
`]
})
export class PaymentSummaryDialog {

    // State of async activity
    loading = false;
    current_desc:string;
    current_remaining:string;
    new_desc:string;
    prod:string;
    current_country;
    item_desc:string;
    sales_tax:number;
    total:number;

    constructor(
        private cd: ChangeDetectorRef,
        public dialogRef: MatDialogRef<PaymentSummaryDialog>,
        public pmt:PaymentService,
        public auth:AuthService,
        public tax:TaxService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if(data.curr.plan == 'free'){
            this.current_desc = '30 day free trial';
            this.current_remaining = data.curr_details;
        }else{

        }
        this.new_desc = data.prod.quantity + ' ' + data.prod.label;
        this.prod = data.prod;
        this.current_country = data.current_country;
        this.item_desc = (data.prod.frequency == 'month' ? 'Monthly subscription: '+this.new_desc : this.new_desc);
        let cost = data.prod.quantity * data.prod.rate;
        this.total = cost;
        if(this.tax.schedule[data.current_country.code] && this.tax.schedule[data.current_country.code].has_sales_tax){
            this.sales_tax = this.tax.schedule[data.current_country.code].calc(cost);
            this.total += this.sales_tax;
        }

    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'payment-source-delete-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog payment-source-delete-dialog">
    <div mat-dialog-title class="warning"><mat-icon (click)="dialogRef.close()">close</mat-icon>Delete Payment Method</div>
    <div mat-dialog-content >
        Are you sure you want to remove this payment method?
        <div class="current">
            {{data.src.owner.name}}
            &nbsp; &nbsp; &nbsp;
            {{ data.src.card.brand }} 
            &bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;{{ data.src.card.last4 }} 
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="dialogRef.close()">CANCEL</button>
        <button mat-button [mat-dialog-close]="data" color="primary" >Remove</button>
    </div>
</div>
`,
    styles:[`
.current { color: #999; margin: 25px 0; }
`]
})
export class PaymentSourceDeleteDialog {

    // State of async activity

    constructor(
        private cd: ChangeDetectorRef,
        public dialogRef: MatDialogRef<PaymentSourceDeleteDialog>,
        public pmt:PaymentService,
        public auth:AuthService,
        public tax:TaxService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {

    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/account/components/dialogs.ts